import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Modal from "@modalSrc/Modal";
import TestDetailsModal from "@modals/TestDetailsModal";
import RightTimeApi from "@/API";
import Helpers from "@/Helpers";

type EFListItem = {
    testId?: number | string;
    testInstanceId?: number | string;
    createDate?: string;
    submitTime?: string;
    jobName?: string;
    siteName?: string;
    firstName?: string;
    lastName?: string;
    state?: string;
};

type EFListModalProps = {
    siteJobId?: number | string | null;
    onClose: () => void;
    updateSpinner: (isLoading: boolean) => void;
};

export default function EFListModal({ siteJobId, onClose, updateSpinner }: EFListModalProps) {
    const [efList, setEfList] = useState<EFListItem[]>([]);
    const [selectedTestInstanceId, setSelectedTestInstanceId] = useState<number | string | null>(null);

    useEffect(() => {
        if (siteJobId) {
            fetchEfList();
        }
    }, [siteJobId]);

    const fetchEfList = async () => {
        updateSpinner(true);
        const response = await RightTimeApi.getAsync(`EFList/${siteJobId}`);
        updateSpinner(false);
        if (response && response.ok) {
            setEfList(Array.isArray(response.jsonData) ? response.jsonData : []);
        }
    };

    if (!siteJobId) {
        return null;
    }

    return (
        <>
            <Modal
                isOpen={!!siteJobId}
                title="Behavioral Expectations"
                onClose={onClose}
                className="efListModal"
            >
                <div className="tableWrapper dimensionTable scrollable">
                    <table>
                        <caption>
                          <span className="title">BE Instances</span>
                        </caption>
                        <thead>
                            <tr>
                                <th>Test ID</th>
                                <th>Test Instance ID</th>
                                <th>Create Date</th>
                                <th>Submit Time</th>
                                <th>Job Name</th>
                                <th>Site Name</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>State</th>
                            </tr>
                        </thead>
                        <tbody>
                            {efList && efList.length > 0 ? (
                                efList.map((ef, index) => (
                                    <tr key={`ef-${ef.testId}-${index}`} className={!ef.submitTime ? "disabled" : ""} onClick={() => setSelectedTestInstanceId(ef.testInstanceId)} style={{ cursor: 'pointer' }}>
                                        <td>{ef.testId}</td>
                                        <td>{ef.testInstanceId || 'N/A'}</td>
                                        <td>{ef.createDate ? Helpers.EST(ef.createDate, "MM/dd/yyyy") : 'N/A'}</td>
                                        <td>{ef.submitTime ? Helpers.EST(ef.submitTime, "MM/dd/yyyy") : 'N/A'}</td>
                                        <td>{ef.jobName || 'N/A'}</td>
                                        <td>{ef.siteName || 'N/A'}</td>
                                        <td>{ef.firstName || 'N/A'}</td>
                                        <td>{ef.lastName || 'N/A'}</td>
                                        <td>{ef.state || 'N/A'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={9} className="center">No Behavioral Expectations (BEs) found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </Modal>
            {createPortal(
                <TestDetailsModal
                    testInstanceId={selectedTestInstanceId}
                    onClose={() => setSelectedTestInstanceId(null)}
                />,
                document.body
            )}
        </>
    );
}


